
<dx-data-grid #gridMovDipendente
  [dataSource]="dataSource"
  [showBorders]="true"
  [focusedRowEnabled]="true"
  [focusedRowIndex]="0"
  [columnAutoWidth]="true"
  [columnHidingEnabled]="true"
  (onExporting)="onExporting($event)">
  <dxo-export [enabled]="exportEnabled"></dxo-export>
  <dxo-editing
    mode="popup"
    [allowAdding]="false"
    [allowDeleting] ="false"
    [useIcons]="false">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
  </dxo-editing>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxi-column
    dataField="id"
    [visible]="false">
  </dxi-column>
  <dxi-column
    dataField="progr">
  </dxi-column>
  <dxi-column
    dataField="idArticolo"
    caption="Articolo"
    [groupIndex]="0">
    <dxo-lookup [dataSource]="listArticoli" valueExpr="id" displayExpr="descrizione" ></dxo-lookup>
  </dxi-column>
  @if (gestMatricole) {
    <dxi-column
      dataField="idArticoloMatricola"
      caption="Matricola">
      <dxo-lookup [dataSource]="listArticoliMatricola" valueExpr="id" displayExpr="matricola" ></dxo-lookup>
    </dxi-column>
  }
  <dxi-column
    dataField="idDipendente"
    caption="Dipendente"
    [visible]="!idDipendente">
    <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" displayExpr="nominativo" ></dxo-lookup>
  </dxi-column>
  <dxi-column
    dataField="data"
    format="dd/MM/yyyy"
    dataType="date"
    [sortIndex]="1"
    sortOrder="desc">
  </dxi-column>
  <dxi-column
    dataField="qta">
  </dxi-column>
  <dxi-column
    dataField="cambio"
    dataType="boolean"
    [visible]="true">
  </dxi-column>
  <dxi-column
    caption="Restituito precedente"
    name="cambioString"
    [formItem]="{ visible: false }"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="restituitoPrecedenteTemplate"
    [visible]="false">
  </dxi-column>
  <div *dxTemplate="let d of 'restituitoPrecedenteTemplate'">
    @if (d.data.cambio) {
      <span>Sì</span>
    }
    @if (!d.data.cambio) {
      <span>No</span>
    }
  </div>


  <dxo-summary>
    <dxi-group-item column="qta"
      summaryType="sum"
      [alignByColumn]="true">
    </dxi-group-item>
    <dxi-group-item column="data"
      summaryType="max"
      [alignByColumn]="true"
      [customizeText]="customizeUltimaConsegna" >
    </dxi-group-item>
  </dxo-summary>



</dx-data-grid>